import { useMemo } from "react";
import { OrganizationCloseStage } from "@common/types/organizationCloseStage";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { useCloseStageSelectFooter } from "./CloseStageSelectFooter";

interface Props {
    hiddenStages: OrganizationCloseStage[];
    onAddStage: (stageId: string) => void;
}

export const AddStageCombobox = ({ hiddenStages, onAddStage }: Props) => {
    const renderStageFooter = useCloseStageSelectFooter();
    const items = useMemo<Array<PickerItemData<string>>>(
        () =>
            hiddenStages.map((stage) => ({
                value: stage.id,
                label: stage.name,
            })),
        [hiddenStages],
    );

    if (hiddenStages.length === 0) {
        return null;
    }

    return (
        <Picker.Select
            searchable
            items={items}
            value={null}
            onValueChange={(stageId) => {
                if (stageId !== null) {
                    onAddStage(stageId);
                }
            }}
            placeholder="Add stage"
            searchPlaceholder="Search stages..."
            emptyLabel="No matching stages"
            chevron="none"
            renderFooter={renderStageFooter}
        />
    );
};
